<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>

<template>
  <div style="display: inline;">
    <div class="bg" style="position: relative;height: 100%;width: 100%;box-sizing: border-box;">
      <div @click="isShowEquipmentAll = false" :style="{ visibility: isShowEquipmentAll ? 'visible' : 'hidden' }" style="position: absolute;z-index: 2;;background: none;height: 100%;width: 100%;display: flex;justify-content: flex-end;">
        <div ref="equipmentPanel" style="overflow: auto;background: gray;height: 60%;width: 60%;margin-top: 120px;background-color: rgba(0,0,0,0.9);padding: 20px;padding-right: 8px;margin-right:34px;display:  flex;flex-flow: wrap;">
          <div @click="changeEq(equipment)" class="eq" v-for="(equipment, index) in $parent.$refs['grid_card'][0].equipments" style="cursor: pointer;background-color: rgba(32, 32, 39, 0.8);display: flex;justify-content: center;align-items: center;margin-right: 12px;border-radius: 2px;margin-bottom: 10px;" :style="{ width: equipmentPanelWidth + 'px', height: (equipmentPanelWidth * 84) / 180 + 'px' }">
            <p :style="{ color: cardTextColor(index) }" style="font-size: 24px;cursor: pointer;">{{ equipment.name }}</p>
          </div>
        </div>
      </div>

      <div ref="header" style="padding: 34px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" src="../../../../../../../assets/img/web/workshop/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">{{ $t('shebeijiankong') }}-{{ equipment.name }}</div>
          <div style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="margin-top: 3px;display: flex;">
              <el-link @click="utils.event_hub.$emit('HIDE_WORKSHOP_EQUIPMENT')" style="color: #419FFF;" icon="yicon yicon-arrow_go_back">{{ $t('chejianjiankong') }}</el-link>
              <el-link @click="
                isShowEquipmentAll = !isShowEquipmentAll;
              resize();
              " style="margin-left: 40px;color: #419FFF;" icon="yicon yicon-arrow_left_right">{{ $t('shebeiqiehuan') }}
              </el-link>
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-if="isShowIsland == false" :refs="'grid_' + item.i" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component v-if="tabsData && tabsData.eqPoints" :equipment="equipment" :tabsData="tabsData" v-bind:is="item.i"> </component>
          </grid-item>
          <grid-item v-if="isShowIsland == true && tabsData && tabsData.eqPoints && tabsData.eqAuxiliaryPoints" :x="0" :y="0" :w="24" :h="24" :i="999" :key="999">
            <component :equipment="equipment" :tabsData="tabsData" v-bind:is="'island'"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import about from '@@/pages/web/monitor/workshop/equipment/about';
import mould from '@@/pages/web/monitor/workshop/equipment/mould';
import alert from '@@/pages/web/monitor/workshop/equipment/alert';
import statistics from '@@/pages/web/monitor/workshop/equipment/statistics';
import island from '@@/pages/web/monitor/workshop/equipment/island';
export default {
  name: 'web_monitor_workshop_equipment_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    about: about,
    mould: mould,
    alert: alert,
    statistics: statistics,
    island: island
  },
  props: {
    equipment: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    equipment: {
      handler(newVal, oldVal) {
        this.getTabsData();
      },
      immediate: true
    }
  },

  data() {
    return {
      timmer: null,
      isShowEquipmentAll: false,
      equipmentPanelWidth: 0,
      tabsData: null,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [
        {
          x: 0,
          y: 0,
          w: 6,
          h: 11, //应该是6
          i: 'about'
        },
        {
          x: 0,
          y: 4,
          w: 6,
          h: 9, //应该是6
          i: 'mould'
        },
        {
          x: 0,
          y: 20,
          w: 6,
          h: 4, //应该是6
          i: 'alert'
        },

        {
          x: 6,
          y: 0,
          w: 18,
          h: 24, //应该是18
          i: 'statistics'
        }
      ],
      isShowIsland: false
    };
  },
  computed: {
    cardTextColor() {
      return index => {
        if (!this.$parent.$refs['grid_card'][0].equipmentsPoints[this.$parent.$refs['grid_card'][0].equipments[index].id]) {
          return '#99A0AD';
        }
        return {
          '0': '#39F16D',
          '3': '#FF3A5E',
          '1': '#FFC83A',
          '-1': '#99A0AD'
        }[this.$parent.$refs['grid_card'][0].equipmentsPoints[this.$parent.$refs['grid_card'][0].equipments[index].id].CurrentState];
      };
    }
  },
  created() {
    this.timmer = setInterval(() => {
      this.getSingleMonitorData();
      this.getSingleAuxiliaryMonitorData();
    }, 120000);

    this.utils.event_hub.$on('SHOW_WORKSHOP_ISLAND', () => {
      if (this.equipment.id != 229) {
        return;
      }
      this.isShowIsland = true;
    });
    this.utils.event_hub.$on('HIDE_WORKSHOP_ISLAND', () => {
      this.isShowIsland = false;
    });

    this.utils.event_hub.$emit('SHOW_WORKSHOP_ISLAND');
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    changeEq(equipment) {
      this.utils.event_hub.$emit('SHOW_WORKSHOP_EQUIPMENT', equipment);
      //this.getTabsData()
      this.isShowEquipmentAll = false;
      this.isShowIsland = false;
    },
    async getTabsData() {
      let response = await this.http.get('/web/config/craft/template/monitor/tab', {
        params: {
          equipmentId: this.equipment.id
        }
      });
      response.data.eqPoints = {};
      this.tabsData = response.data;
      this.getSingleMonitorData();
      this.getSingleAuxiliaryMonitorData();
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;

        this.equipmentPanelWidth = (this.$refs.equipmentPanel.offsetWidth - 28 - 84) / 7;
      }, 500);
    },
    async getSingleMonitorData() {
      let response = await this.http.get('/web/equipment/getSingleMonitorData', {
        params: {
          equipmentId: this.equipment.id
        }
      });
      this.tabsData.eqPoints = response.data;
    },
    async getSingleAuxiliaryMonitorData() {
      let response = await this.http.get('/web/equipment/getSingleAuxiliaryMonitorData', {
        params: {
          equipmentId: this.equipment.id
        }
      });
      this.tabsData.eqAuxiliaryPoints = response.data;
    }
  }
};
</script>
